module.exports = __webpack_public_path__ + "img/syarat-dan-ketentuan.8b10871a.svg";